import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="py-32 text-center" data-testid="page-notfound">
      <div className="eyebrow mb-4 text-sage">404</div>
      <h1 className="font-serif-display text-5xl md:text-6xl text-ink">Not here. Yet.</h1>
      <p className="mt-4 text-ink-soft">The page you're looking for doesn't exist.</p>
      <Link
        to="/"
        className="mt-10 inline-flex items-center gap-2 bg-sage hover:bg-sage-dark text-cream rounded-full px-8 py-4 font-medium"
      >
        Back home
      </Link>
    </section>
  );
}
